module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/focus--value-for-money.b7a32d1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/focus--value-for-money.pdf
// module id = gmUy
// module chunks = 10